import { useMemo } from 'react';
import { formatTranslation } from 'intl';
import { useIntl } from 'react-intl';
import { GridColumnGroupingModel } from '@mui/x-data-grid-pro';
import { GridColumnFieldCompany } from 'components/common/dataGrid/columnsFactory/types';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { ExtendedFieldTranslationKeys } from 'intl/keys';

export function useCompanyColumnGroupingModel(): GridColumnGroupingModel {
  const intl = useIntl();

  return useMemo<GridColumnGroupingModel>(
    () => [
      {
        groupId: formatTranslation(intl, ExtendedFieldTranslationKeys.finalCost ),
        children: [
          { field: GridColumnFieldCompany.finalCostSettled },
          { field: GridColumnFieldCompany.finalCostOutstanding },
        ],
      },
      {
        groupId: formatTranslation(intl, ProjectSetupTranslationKeys.correspondenceAddressFieldLabel,),
        children: [
          { field: GridColumnFieldCompany.correspondenceAddressStreetAndNumber },
          { field: GridColumnFieldCompany.correspondenceAddressPostalCode },
          { field: GridColumnFieldCompany.correspondenceAddressCountry },
        ],
      },
      {
        groupId: formatTranslation(intl, ProjectSetupTranslationKeys.registeredOfficeAddress,),
        children: [
          { field: GridColumnFieldCompany.registeredAddressStreetAndNumber },
          { field: GridColumnFieldCompany.registeredAddressPostalCode },
          { field: GridColumnFieldCompany.registeredAddressCountry },
        ],
      },
    ],
    [intl]
  );
}

